module.exports = __webpack_public_path__ + "static/media/biostor-ireland.b8e921b7.png";